/**
 * useDebounce — returns a value that follows `source` after `ms` ms of quiet.
 * Used to avoid hitting the backend on every keystroke in search inputs.
 */
import { useEffect, useState } from 'react';

export function useDebounce<T>(source: T, ms: number): T {
  const [debounced, setDebounced] = useState(source);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(source), ms);
    return () => clearTimeout(timer);
  }, [source, ms]);

  return debounced;
}
